import React from 'react';

const LanguageContext = React.createContext();
const LanguageConsumer = LanguageContext.Consumer;

export { LanguageContext, LanguageConsumer };
